import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionSummary from '@mui/material/AccordionSummary';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import { secondaryText, mainText, accordionSummary, iconBox, menuItems } from './EmployeeSummary.sx';
import NameChangeModal from 'app/components/NameChangeModal';
import ProfileIcon from 'app/components/Icons/ProfileIcon';
import TableDotsIcon from 'app/components/Icons/TableDotsIcon';
import EditIcon from 'app/components/Icons/EditIcon';
import BinIcon from 'app/components/Icons/BinIcon';
import LockIcon from 'app/components/Icons/LockIcon';
import logger from 'app/utils/logger/logger';

interface Status {
  value: string;
  label: string;
  icon: JSX.Element;
}
interface SummaryProps {
  id: number;
  headerText: string;
  email: string;
  position: string;
  open?: boolean;
  setOpen?: (arg?: boolean) => void;
  status?: Status;
  anchorEl: any;
  activeAnchor: string;
  handleMenuClick: (e: any, status: any, id: any) => void;
  handleClose: () => void;
  employeeStatus?: any;
}
const EmployeeSummary = (props: SummaryProps) => {
  const {
    headerText,
    email,
    status,
    open,
    position,
    anchorEl,
    activeAnchor,
    handleMenuClick,
    handleClose,
    id,
    employeeStatus,
  } = props;
  const [openNameChangeModal, setOpenNameChangeModal] = useState(false);

  return (
    <>
      <AccordionSummary
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={{
          ...accordionSummary,
          '& .MuiAccordionSummary-expandIconWrapper > .MuiSvgIcon-root > path': {
            fill: status.value !== 'closed' ? '#14191F' : '#14191F38',
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Box sx={{ display: 'flex', gap: '24px', flexDirection: 'row', alignItems: 'center' }}>
            <img src="/images/user.png" alt="photo-user" height={44} />
            <Box sx={{ display: 'flex', gap: '2px', flexDirection: 'column' }}>
              <Typography sx={mainText}>{headerText}</Typography>
              <Typography sx={secondaryText}>{position}</Typography>
            </Box>
          </Box>
          <Typography sx={secondaryText}>{email}</Typography>
          <Box sx={{ display: 'flex', gap: '28px', alignItems: 'center' }}>
            <Box
              sx={{ display: 'flex', justifyContent: 'flex-end', gap: '16px', alignItems: 'center', width: '138px' }}
            >
              {status.icon}
              <Typography>{status.label}</Typography>
            </Box>
            <TableDotsIcon
              sx={{ '&:hover': { cursor: 'pointer' } }}
              onClick={(event: any) => handleMenuClick(event, status.value, id)}
              aria-controls={anchorEl ? `actions-${id}` : undefined}
              aria-haspopup="true"
              aria-expanded={anchorEl ? 'true' : undefined}
            />
          </Box>
        </Box>
      </AccordionSummary>

      <NameChangeModal
        open={openNameChangeModal}
        close={setOpenNameChangeModal}
        headerText={'Hesabın adını dəyiş'}
        inputTitle={'Hesabın adı'}
        selectName={headerText}
      />
    </>
  );
};

export default EmployeeSummary;
